<template>
	<div>
		<topTab ref="topTab" :tab-data="tabData" @tab-change="changePages">
			<lcsj-filter :show-search="false" more-text="更多筛选" @search="inputChange()">
			<template #query>
				<el-button v-if="$checkBtnPermission('/productType/index', 'viewPage')" size="small" type="primary" class="el-icon-search" @click="inputChange()">搜索</el-button>
			</template>
			<template #actions><el-button v-if="$checkBtnPermission('/productType/index', 'create')" size="small" type="primary" class="el-icon-plus" @click="handleEditClick()">新增</el-button><el-button v-if="$checkBtnPermission('/productType/index', 'createStoreProduct')" size="small" type="primary" class="el-icon-plus" @click="handleShowCreateStoreProduct">		创建门店库存	</el-button></template>
			<el-form-item label="类型：">
					<el-select v-model="formInline.typeName" placeholder="请选择类型" clearable size="small" filterable @change="handleTypeNameChange">
						<el-option v-for="item in typeNameList" :key="item.value" :label="item.value" :value="item.value"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="系列：">
					<el-select v-model="formInline.productName" placeholder="请选择系列" clearable size="small" filterable @change="inputChange">
						<el-option v-for="item in subNameList" :key="item.value" :label="item.value" :value="item.value"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="商品名称：">
					<el-input v-model="formInline.specification" placeholder="请输入商品名称" clearable size="small"></el-input>
				</el-form-item>
				<el-form-item label="是否有库存：">
					<el-select v-model="formInline.isWareHouse" placeholder="请选择是否有库存" size="small">
						<el-option label="全部" :value="null"></el-option>
						<el-option label="是" :value="true"></el-option>
						<el-option label="否" :value="false"></el-option>
					</el-select>
				</el-form-item>
			</lcsj-filter>
			<STable :columns="columnsData" :data="listData" :loading="loading" border stripe row-key="keyId" @row-db-click="handleEditClick" @selection-change="handleSelectionChange">
				<template #code>
					<el-table-column label="商品编码" min-width="200" align="center">
						<template #default="scope">
							<el-link type="primary" :underline="false" @click="handleShowHistory(scope.row)">
								{{ scope.row.code }}
							</el-link>
						</template>
					</el-table-column>
				</template>
				<template #isWarehouse>
					<el-table-column label="真实库存" min-width="120" align="center">
						<template #default="scope">
							{{ scope.row.isWareHouse === true ? "是" : "否" }}
						</template>
					</el-table-column>
				</template>
			</STable>
			<!-- 分页组件 -->
			<Pagination v-if="pageShow" :child-msg="pageparm" @call-father="callFather"></Pagination>
		</topTab>
		<!-- 编辑 -->
		<edit ref="edit"></edit>
		<!-- 历史记录 -->
		<history ref="history"></history>
		<!-- 产品类型历史记录 -->
		<lcsj-dialog v-model="dialogVisible" :title="title" width="720px" cancel-text="关闭" confirm-text="确认"
			 :close-on-click-modal="false"
			 :confirm-loading="isSubmitting" @confirm="handleBatchCreateStoreProduct"> <span style="display: block; margin-bottom: 10px"><strong>门店:</strong></span>
			<el-select v-model="selectedStoreKeyId" placeholder="请选择门店" filterable style="width: 100%">
				<el-option v-for="item in storeList" :key="item.keyId" :label="item.value" :value="item.keyId"></el-option>
			</el-select></lcsj-dialog>
	</div>
</template>

<script>
import { GetProductTypePageList, BatchCreateStoreProduct, GetProductTypeNameList, GetProductTypeSubNameList } from "@/api/productApi.js";
import { GetOrgInfoListByConfig } from "@/api/organizationalApi.js";
import edit from "./edit.vue";
import history from "./history.vue";
export default {
	data() {
		return {
			activeTab: "1",
			tabData: [
				{
					key: "1",
					value: "商品类型"
				}
			],
			pageShow: true,
			loading: false, // 显示加载
			listData: [],
			// 分页参数
			pageparm: {
				pageIndex: 1,
				pageSize: 10,
				total: 0
			},
			formInline: {
				pageIndex: 1,
				pageSize: 10,
				typeName: "",
				productName: "",
				specification: "",
				isWareHouse: null
			},
			selectionRowKeyIds: [],
			columnsData: [], //显示列
			listColumns: [
				{
					prop: "keyId",
					label: "全选",
					align: "center",
					width: "55",
					isKeep: true,
					selection: true
				},
				{
					prop: "rowNumber",
					label: "序号",
					align: "center",
					width: "80",
					isKeep: true
				},
				{
					slot: "code",
					label: "商品编码",
					isKeep: true,
					minWidth: "170",
					align: "center",
				},
				{
					prop: "typeName",
					label: "类型",
					width: "120",
					align: "center"
				},
				{
					prop: "productName",
					label: "系列",
					width: "180",
					align: "center"
				},
				{
					prop: "specification",
					label: "商品名称",
					width: "150",
					align: "center"
				},
				{
					prop: "unit",
					label: "单位",
					width: "120",
					align: "center"
				},
				{
					prop: "price",
					label: "价格(元)",
					width: "120",
					align: "center",
					isMoney: true,
					moneyType: "normal"
				},
				{
					slot: "isWarehouse",
					label: "真实库存",
					width: "120",
					align: "center"
				},
				{
					prop: "creator",
					label: "创建人",
					width: "120",
					align: "center"
				},
				{
					prop: "createTime",
					label: "创建时间",
					width: "170",
					align: "center"
				},
				{
					prop: "editor",
					label: "维护人",
					width: "120",
					align: "center"
				},
				{
					prop: "updateTime",
					label: "维护时间",
					width: "170",
					align: "center"
				}
			],
			// 历史记录弹窗
			dialogVisible: false,
			title: "创建门店库存",
			selectedStoreKeyId: "",
			storeList: [],
			isSubmitting: false,
			// 产品类型名称列表
			typeNameList: [],
			// 产品类型子名称列表
			subNameList: []
		};
	},
	// 注册组件
	components: {
		edit,
		history
	},
	created() {
		// 初始列
		this.getCheckBox(this.listColumns.map((item) => item.label));
		this.getListData();
		this.GetOrgInfoListByConfig();
		this.getProductTypeNameList();
		this.getProductTypeSubNameList("");
	},
	computed: {},
	methods: {
		// 获取筛选框
		getCheckBox(val) {
			let arr = this.listColumns.filter((v) => !val.includes(v.label));
			this.columnsData = this.listColumns.filter((i) => !arr.includes(i));
		},
		changePages() {},
		// 获取列表
		getListData() {
			this.loading = true;
			GetProductTypePageList(this.formInline)
				.then((res) => {
					if (res.code == 1) {
						this.loading = false;
						this.listData = res.data;
						this.pageparm.total = res.totalNumber;
					} else {
						this.$message({
							type: "info",
							message: res.msg
						});
					}
				})
				.catch((err) => {
					this.loading = false;
					this.$message.error("数据加载失败，请稍后再试！");
				});
		},
		inputChange() {
			this.search();
		},
		// 分页插件事件
		callFather(parm) {
			if (parm.currentPage == undefined) {
				this.formInline.pageIndex = 1;
			} else {
				this.formInline.pageIndex = parm.currentPage;
			}
			this.formInline.pageSize = parm.pageSize;
			this.getListData();
		},
		// 搜索事件
		search() {
			this.formInline.pageIndex = 1;
			this.pageShow = false;
			this.$nextTick(() => {
				this.pageShow = true;
			});
			this.getListData();
		},
		// 点击事件
		handleEditClick(row) {
			this.$refs.edit.editShow(row);
		},
		handleShowHistory(row) {
			this.$refs.history.showHistoryDialog(row.keyId, row.code);
		},
		// 选择行
		handleSelectionChange(val) {
			this.selectionRowKeyIds = val.map((item) => item.keyId);
		},
		// 获取所属门店
		GetOrgInfoListByConfig() {
			const paramer = {
				key: 1
			};
			GetOrgInfoListByConfig(paramer)
				.then((res) => {
					if (res.code == 1) {
						this.storeList = [];
						if (res.code == 1) {
							res.data.forEach((item) => {
								this.storeList.push({
									keyId: item.keyId,
									value: item.name + "【" + item.remark2 + "】"
								});
							});
						} else {
							this.$message.error(res.msg);
						}
					} else {
						this.$message.error(res.msg);
					}
				})
				.catch((err) => {
					this.loading = false;
					this.$message.error("获取门店信息失败!");
				});
		},
		// 创建门店库存
		handleBatchCreateStoreProduct() {
			if (this.selectionRowKeyIds.length == 0) {
				this.$message({
					type: "info",
					message: "请选择商品类型！"
				});
				return;
			}
			if (this.selectedStoreKeyId == "") {
				this.$message({
					type: "info",
					message: "请选择门店！"
				});
				return;
			}
			this.$confirm("确认创建选中商品类型的门店库存吗？", "提示", {
				confirmButtonText: "确定",
				cancelButtonText: "取消",
				type: "warning"
			}).then(() => {
				this.isSubmitting = true;
				BatchCreateStoreProduct({
					keyIds: this.selectionRowKeyIds,
					storeKeyId: this.selectedStoreKeyId
				})
					.then((res) => {
						if (res.code == 1) {
							this.$message({
								type: "success",
								message: "创建成功！"
							});
							this.dialogVisible = false;
							this.getListData();
						} else {
							this.$message({
								type: "info",
								message: res.msg
							});
						}
					})
					.finally(() => {
						this.isSubmitting = false;
					});
			});
		},
		// 显示创建门店库存弹窗
		handleShowCreateStoreProduct() {
			this.dialogVisible = true;
			this.selectedStoreKeyId = "";
		},
		getProductTypeNameList() {
			GetProductTypeNameList({}).then((res) => {
				if (res.code == 1) {
					this.typeNameList = [];
					if (res.code == 1) {
						res.data.forEach((item) => {
							this.typeNameList.push({
								keyId: item.value,
								value: item.value
							});
						});
					} else {
						this.$message.error(res.msg);
					}
				} else {
					this.$message.error(res.msg);
				}
			});
		},
		getProductTypeSubNameList(code) {
			var params = {
				code: code
			};
			GetProductTypeSubNameList(params).then((res) => {
				if (res.code == 1) {
					this.subNameList = [];
					if (res.code == 1) {
						res.data.forEach((item) => {
							this.subNameList.push({
								keyId: item.value,
								value: item.value
							});
						});
					} else {
						this.$message.error(res.msg);
					}
				} else {
					this.$message.error(res.msg);
				}
			});
		},
		// 类型名称改变事件
		handleTypeNameChange(val) {
			this.formInline.productName = "";
			this.getProductTypeSubNameList(val);
			this.search();
		}
	}
};
</script>

<style scoped></style>
